import React from 'react';
import PropTypes from 'prop-types';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './styles';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    inputUnderline: PropTypes.string,
    inputRoot: PropTypes.string,
    tooltip: PropTypes.string,
    startInputAdornmentRoot: PropTypes.string,
    label: PropTypes.string,
    labelFocused: PropTypes.string,
    labelShrink: PropTypes.string,
    errorTextStyle: PropTypes.string,
  }).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  touched: PropTypes.bool,
  invalid: PropTypes.bool,
  errMsg: PropTypes.string,
  tooltip: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  disabled: PropTypes.bool,
  isPhone: PropTypes.bool,
  options: PropTypes.array,
  countryCode: PropTypes.string,
};

const defaultProps = {
  tooltip: '',
  errMsg: '',
  value: '',
  onFocus: () => {},
  onBlur: () => {},
  onChange: () => {},
  invalid: false,
  touched: false,
  disabled: false,
  countryCode: '',
};

const GeneralTextField = props => {
  const {
    classes,
    value,
    onChange,
    onBlur,
    onFocus,
    errMsg,
    touched,
    invalid,
    tooltip,
    disabled,
    isPhone,
    countryCode,
    options,
    ...otherProps
  } = props;

  const getInputProps = () => {
    const inputProps = {
      classes: {
        underline: classes.inputUnderline,
        root: classes.inputRoot,
      },
    };

    if (tooltip) {
      inputProps.endAdornment = (
        <InputAdornment position="end">
          <Tooltip
            title={tooltip}
            placement="top"
            classes={{ tooltip: classes.tooltip }}
          >
            <InfoIcon />
          </Tooltip>
        </InputAdornment>
      );
    }

    if (isPhone) {
      inputProps.startAdornment = (
        <InputAdornment
          position="start"
          className={classes.startInputAdornmentRoot}
        >
          +{countryCode}
        </InputAdornment>
      );
    }

    return inputProps;
  };

  return (
    <MuiTextField
      className={classes.root}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      disabled={disabled}
      InputProps={getInputProps()}
      InputLabelProps={{
        classes: {
          root: classes.label,
          focused: classes.labelFocused,
          shrink: classes.labelShrink,
        },
      }}
      FormHelperTextProps={{
        classes: {
          error: classes.errorTextStyle,
        },
      }}
      error={touched && invalid}
      helperText={touched && errMsg}
      {...otherProps}
    >
      {options &&
        options.map(item => (
          <MenuItem value={item.value} key={item.value}>
            {item.name}
          </MenuItem>
        ))}
    </MuiTextField>
  );
};

GeneralTextField.propTypes = propTypes;
GeneralTextField.defaultProps = defaultProps;

export default withStyles(styles)(GeneralTextField);
